import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhoWeAre from "./pages/WhoWeAre";
import WhatWeDo from "./pages/WhatWeDo";
import EngageWithUs from "./pages/EngageWithUs";
import PartnerWithUs from "./pages/PartnerWithUs";
import ConnectWithUs from "./pages/ConnectWithUs";
import TopicPage from "./pages/TopicPage";

const initTheme = () => {
  const params = new URLSearchParams(window.location.search);
  const forced = params.get("theme");
  const stored = localStorage.getItem("xsi-theme");
  const isDark = forced
    ? forced === "dark"
    : stored
    ? stored === "dark"
    : window.location.hostname.includes("xcelsior");
  document.documentElement.classList.toggle("dark", isDark);
};
initTheme();

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<WhoWeAre />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/engage" element={<EngageWithUs />} />
          <Route path="/partner" element={<PartnerWithUs />} />
          <Route path="/connect" element={<ConnectWithUs />} />
          <Route path="/explore/:slug" element={<TopicPage />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
